import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustImgImpStepsComponent } from '../customer/dialog/import-steps/cust-img-imp-steps/cust-img-imp-steps.component';
import { DecDataImportStepsComponent } from '../decoded-data/dialog/import-steps/dec-data-import-steps/dec-data-import-steps.component';
import { DecImgImportStepsComponent } from '../decoded-data/dialog/import-steps/dec-img-import-steps/dec-img-import-steps.component';
import { DevImpStepsComponent } from '../device/dialogs/import-steps/dev-imp-steps/dev-imp-steps.component';
import { ProdImgImpStepsComponent } from '../product/dialog/import-steps/prod-img-imp-steps/prod-img-imp-steps.component';
import { ProdImgTempImpStepsComponent } from '../product/dialog/import-steps/prod-img-temp-imp-steps/prod-img-temp-imp-steps.component';
import { SalCondImgImpStepsComponent } from '../salesconditions/dialog/import-steps/sal-cond-img-imp-steps/sal-cond-img-imp-steps.component';
import { UserImpStepsComponent } from '../user/dialogs/import-steps/user-imp-steps/user-imp-steps.component';

@NgModule({
  declarations: [
    DecDataImportStepsComponent,
    DecImgImportStepsComponent,
    DevImpStepsComponent,
    ProdImgImpStepsComponent,
    ProdImgTempImpStepsComponent,
    SalCondImgImpStepsComponent,
    UserImpStepsComponent,
    CustImgImpStepsComponent
  ],
  imports: [CommonModule, TranslateModule],
  exports: [
    DecDataImportStepsComponent,
    DecImgImportStepsComponent,
    DevImpStepsComponent,
    ProdImgImpStepsComponent,
    ProdImgTempImpStepsComponent,
    SalCondImgImpStepsComponent,
    UserImpStepsComponent,
    CustImgImpStepsComponent
  ]
})
export class ImportstepsModule {}
